import React from 'react';
import { Box, Stack, TextField } from '@mui/material';
import TopBar from '../../../components/TopBar';
import PartnerListPageActions from '../components/PartnerListPageActions';
import PartnersTable from '../components/PartnersTable';
import usePartnerFilters from '../components/PartnerFilterHelper';

export default function PartnerListPage() {
  const { searchTerm, currentQuery, pagination, handleSearchChange, handleSearchKeyDown, handlePaginationChange } =
    usePartnerFilters({ defaultQuery: {} });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Partners">
        <PartnerListPageActions />
      </TopBar>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <TextField
          label="Search by name or email"
          placeholder="Search by name or email"
          value={searchTerm}
          onChange={(event) => handleSearchChange(event.target.value)}
          onKeyDown={handleSearchKeyDown}
          size="small"
          sx={{ width: 320 }}
        />
      </Box>
      <PartnersTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={currentQuery}
        paginationModel={{ page: pagination.page, pageSize: pagination.size }}
      />
    </Stack>
  );
}
